import React from 'react';
import {styles} from "./ProgressBarViewStyle";
import {Text, View} from "react-native";
import Project from "../../../../../../../Common/DTO/Project";

interface ProgressBarViewProps {
    project: Project;
    isMobile: boolean;
}

export const ProgressBarView = ({project, isMobile}: ProgressBarViewProps) => {
    const minInvestment: number = project.minimumInvest;
    const maxInvestment: number = project.maximumInvest;
    const currentInvestment = project.currentInvest;

    let minInvestPercentage: number = (currentInvestment / minInvestment > 1
        ? 1
        : currentInvestment / minInvestment) * 100;
    minInvestPercentage = Math.floor(minInvestPercentage);

    let maxInvestPercentage: number = (currentInvestment-minInvestment <= 0
        ? 0
        : (currentInvestment-minInvestment)/ (maxInvestment-minInvestment)) * 100;
    maxInvestPercentage = Math.floor(maxInvestPercentage);

    const minFullyInvest = minInvestment <= currentInvestment;

    const textStyle = {
        zIndex: 10,
        color: 'rgb(83, 83, 83)',
        fontSize: 14,
        marginLeft: 12,
    };

    return (
        <View style={[styles.container, {width: isMobile ? '75%' : '95%'}]}>
            <View style={[styles.minInvestContainer, minFullyInvest ? {width: '66.6%'} : {width: '100%'}]}>
                <View style={[styles.minInvestFill, {width: `${minInvestPercentage}%`}]}>
                    <Text style={[textStyle, {fontWeight: "bold", position: 'absolute'}]}>{minInvestPercentage}%</Text>
                </View>
            </View>
            {minFullyInvest && (
                <View style={[styles.maxInvestContainer, {borderTopLeftRadius: 0, borderBottomLeftRadius: 0}]}>
                    <View  style={[styles.maxInvestFill, {width: `${maxInvestPercentage}%`}]}>
                        <Text style={[textStyle, {fontWeight: "bold", position: 'absolute'}]}>{maxInvestPercentage}%</Text>
                    </View>
                </View>
            )}

        </View>
    );
}

export default ProgressBarView;